/* eslint-disable @typescript-eslint/no-explicit-any */
import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Row, Select } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  RangePicker,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  PartsServicesFormValues,
  PartsServicesStatus,
} from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import moment from 'moment';

interface Props {
  form: FormInstance<PartsServicesFormValues>;
}

function PartsAndServicesModalForm({ form }: Props) {
  const intl = useIntl();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name="dates"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.startDate.endDate',
            })}
            rules={[defaultEmptyFieldError]}
            initialValue={[moment().subtract(5, 'months'), moment()]}
          >
            <RangePicker style={{ width: '100%', height: 48 }} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="companiesIds"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.companies',
            })}
          >
            <CompaniesInfiniteSelectField
              queryFilter={{ rows: 50 }}
              mode="multiple"
              allowClear
              buttonSelectAll
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="status"
            label="Status O.S"
            initialValue={[PartsServicesStatus.closed]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              options={[
                {
                  label: 'Autorizado',
                  value: PartsServicesStatus.authorized,
                },
                {
                  label: 'Fechado',
                  value: PartsServicesStatus.closed,
                },
              ]}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default PartsAndServicesModalForm;
